const styles = {
  space: (height) => ({ height: height }),
};

export default styles;
